import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pick-a-card-categories" }
const _hoisted_2 = { class: "configurator-pick-a-card_options" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", {
    ref: "wrapper",
    class: _normalizeClass(["pick-a-card__app", { touched: $setup.isFormSubmitted }])
  }, [
    _createElementVNode("header", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.settings?.collection_groups, (collection) => {
        return (_openBlock(), _createBlock($setup["CategoryLabel"], {
          "is-active": $setup.selectedCategory === collection.label,
          key: collection.slug,
          label: collection.label,
          products: collection.products,
          onSelected: () => $setup.selectCategory(collection.label, collection.products)
        }, null, 8 /* PROPS */, ["is-active", "label", "products", "onSelected"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cards, (card) => {
        return (_openBlock(), _createBlock($setup["Card"], {
          key: card.id,
          card: card,
          "is-active": $setup.selectedCard === card.variants.at(0)?.id,
          onCardPicked: 
          () => {
            $setup.skippedCard = false;
            $setup.enableMessageBlock();
            $setup.selectCard(card);
          }
        
        }, null, 8 /* PROPS */, ["card", "is-active", "onCardPicked"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    ($setup.settings?.show_no_card)
      ? (_openBlock(), _createBlock($setup["ContinueWithoutCard"], {
          key: 0,
          label: $setup.settings?.no_card_button_label ?? '',
          onSkipCardSelection: $setup.skipCardSelection
        }, null, 8 /* PROPS */, ["label"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}